import React, { useEffect, useState } from 'react';
import { galeriaPublicaService } from '../../api/services';
import { Loading, Vazio } from '../../components/ui';
import type { Imagem } from '../../types';
import './eventos.css';
import '../public/sobre.css';

export default function FestejoPage() {
  const [imagens, setImagens] = useState<Imagem[]>([]);
  const [carregando, setCarregando] = useState(true);
  const [selecionada, setSelecionada] = useState<Imagem | null>(null);

  useEffect(() => {
    galeriaPublicaService.listar('festejo')
      .then(r => setImagens(r.imagens))
      .catch(() => {})
      .finally(() => setCarregando(false));
  }, []);

  return (
    <div className="festejo-page">
      {/* Header especial */}
      <section className="page-header" style={{ background: 'linear-gradient(135deg, #0a1628 0%, #1a2d4f 100%)' }}>
        <div className="container">
          <div className="page-header-conteudo" style={{ textAlign: 'center', maxWidth: '100%' }}>
            <div className="cta-icones" style={{ fontSize: '3rem', letterSpacing: '0.5rem', marginBottom: '1rem' }}>
              🎪 🌟 🎶 🔥
            </div>
            <div className="secao-tag">Cultura Junina</div>
            <h1>Festejo Junino de Marabá</h1>
            <p>A maior celebração da cultura junina de Marabá, com quadrilhas, bois bumbas e marcadores.</p>
            <p style={{ color: 'var(--dourado)', fontWeight: 700, marginTop: '0.5rem' }}>
              "Juntos Somos Mais Fortes!" ★
            </p>
          </div>
        </div>
      </section>

      {/* Sobre o festejo */}
      <section className="festejo-sobre">
        <div className="container">
          <div className="festejo-sobre-grid">
            <div className="festejo-sobre-texto">
              <div className="secao-tag">Nossa Tradição</div>
              <h2 className="secao-titulo">O Festejo Junino da LICMAB</h2>
              <p>
                O Festejo Junino de Marabá é uma das maiores expressões da cultura popular paraense, 
                promovido pela LICMAB com o objetivo de preservar e difundir a cultura junina local.
              </p>
              <p>
                Com grupos de quadrilha, bois bumbas e marcadores da cidade, o festejo celebra 
                a tradição, a identidade cultural e a alegria do povo marabaense.
              </p>
              <p>
                Um dos objetivos fundamentais da LICMAB, conforme seu estatuto, é lutar pelo 
                resgate da Cultura Junina, do Folclore Brasileiro e das Artes Cênicas tradicionais do nosso país.
              </p>
            </div>
            <div className="sobre-numeros">
              {[
                { num: '🎭', label: 'Quadrilhas' },
                { num: '🐂', label: 'Bois Bumbas' },
                { num: '🎵', label: 'Marcadores' },
                { num: '🌟', label: 'Cultura Viva' },
              ].map((item, i) => (
                <div key={i} className="numero-card">
                  <span className="numero-valor" style={{ fontSize: '2.5rem' }}>{item.num}</span>
                  <span className="numero-label">{item.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Galeria do festejo */}
      <section className="festejo-conteudo">
        <div className="container">
          <h2 className="secao-titulo" style={{ marginBottom: '2rem' }}>Galeria do Festejo</h2>
          {carregando ? (
            <Loading mensagem="Carregando galeria..." />
          ) : imagens.length === 0 ? (
            <Vazio
              icone={<span style={{ fontSize: '4rem' }}>🎪</span>}
              titulo="Galeria em breve"
              descricao="As fotos do festejo serão publicadas aqui em breve."
            />
          ) : (
            <div className="galeria-grid">
              {imagens.map(img => (
                <div
                  key={img.id}
                  className="galeria-item"
                  onClick={() => setSelecionada(img)}
                >
                  <img src={img.urlPublica} alt={img.titulo} loading="lazy" />
                  <div className="galeria-overlay">
                    <p>{img.titulo}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Lightbox */}
      {selecionada && (
        <div className="lightbox" onClick={() => setSelecionada(null)}>
          <button className="lightbox-fechar" onClick={() => setSelecionada(null)}>✕</button>
          <div className="lightbox-conteudo" onClick={e => e.stopPropagation()}>
            <img src={selecionada.urlPublica} alt={selecionada.titulo} />
            <p className="lightbox-titulo">{selecionada.titulo}</p>
          </div>
        </div>
      )}
    </div>
  );
}
